
import {WORK_AMOUNT_UNIT_FLATFEE} from '../../../constants'
import {validateField, submitFields, clearFields, clearField, setFieldOptions, setFieldRequired} from './helpers/form'
import {
  FETCH_VOICE_TEST_ACTIVATE_DATA_SUCCESS,
  VALIDATE_VOICE_TEST_ACTIVATE_FIELD,
  VALIDATE_VOICE_TEST_ACTIVATE_WORK_AMOUNT_UNIT_FIELD,
  SUBMIT_VOICE_TEST_ACTIVATE_FIELDS,
  CLEAR_VOICE_TEST_ACTIVATE_FIELDS,
  CLEAR_VOICE_TEST_ACTIVATE_FIELD
} from '../../../actions/pages/voice-test-page'

export function voiceTestActivate(
  state = {
    valid: false,
    fields: [
      {
        name: 'Deadline',
        value: '',
        errors: [],
        rules: {
          title: 'Deadline'
        }
      },
      {
        name: 'WorkAmountQuantity',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Work amount quantity',
          required: true,
          numericGreaterThanZero: true
        },
        disabled: false
      },
      {
        name: 'WorkAmountUnit',
        value: '',
        errors: [],
        placeholder: ' ',
        rules: {
          title: 'Work amount unit',
          required: true
        },
        options: []
      },
      {
        name: 'AdditionalNotes',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Notes',
          max: '1000'
        }
      },
      {
        name: 'Description',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Description',
          min: 0,
          max: '30'
        }
      },
      {
        name: 'VisibilityType',
        value: '',
        errors: [],
        placeholder: '',
        rules: {
          required: true,
          title: 'Visibility'
        },
        options: [],
        filteredOptions: [],
        isNullable: false
      },
    ]
  },
  action
) {
  switch (action.type) {
    case FETCH_VOICE_TEST_ACTIVATE_DATA_SUCCESS: {
      let fields = state.fields.map((field) => {
        let newValue;
        Object.entries(action.data).forEach(([key, value]) => {
          if (field.name === key){
            newValue = value;
            return;
          }
        })

        if (newValue !== undefined) {
          if (field.name == 'Description' && action.descriptionRequired) {
            return {
              ...field,
              value: newValue,
              errors: [],
              rules: {
                title: field.rules.title,
                min: 1,
                max: field.rules.max
              }
            }
          }

          return {
            ...field,
            value: newValue,
            errors: []
          }
        }

        return field;
      })

      let newState =  Object.assign({}, state, {
        valid: true,
        fields: Array.from(fields)
      })

      action.data.WorkAmountUnits.Items = action.data.WorkAmountUnits.Items.map(function (unit) {
        unit.label = unit.label.charAt(0).toUpperCase() + unit.label.slice(1);
        return unit;
      });

      newState = setFieldOptions(newState, 'WorkAmountUnit', action.data.WorkAmountUnits);

      newState = setDisableWorkAmountQuantity(newState);
      return setRequireCustomRate(newState);
    }

    case VALIDATE_VOICE_TEST_ACTIVATE_FIELD: {
      let newState = validateField(state, action);

      newState = setRequireCustomRate(newState);

      return newState;
    }

    case VALIDATE_VOICE_TEST_ACTIVATE_WORK_AMOUNT_UNIT_FIELD: {
      let newState = validateField(state, action);

      var selectedWorkAmountUnit = action.field.value;

      let fields = newState.fields.map(item => {
        if (item.name === 'StandardRate') {
          var filteredStandardRateOptions = item.options.filter((option) => {
            return (selectedWorkAmountUnit === option.parameters.unit);
          });

          let selectedStandardRate = filteredStandardRateOptions.length > 0 ? filteredStandardRateOptions[0].value : '';

          return Object.assign({}, item, {
            filteredOptions: filteredStandardRateOptions,
            value: selectedStandardRate
          })
        } else {
          return item
        }
      })

      newState = Object.assign({}, newState, {
        fields: Array.from(fields)
      })

      newState = setDisableWorkAmountQuantity(newState);
      return setRequireCustomRate(newState);
    }

    case SUBMIT_VOICE_TEST_ACTIVATE_FIELDS:
      return submitFields(state, action);

    case CLEAR_VOICE_TEST_ACTIVATE_FIELDS:
      return clearFields(state);

    case CLEAR_VOICE_TEST_ACTIVATE_FIELD:
      return clearField(state, action.fieldName);

    default:
      return state
  }
}

function setDisableWorkAmountQuantity(state) {
  var workAmountUnitField = state.fields.find((el) => {
    return el.name === 'WorkAmountUnit';
  });

  let fields = state.fields.map(item => {
    if (item.name === 'WorkAmountQuantity') {
      if (workAmountUnitField.value === WORK_AMOUNT_UNIT_FLATFEE) {
        return Object.assign({}, item, {
          errors: [],
          value: 1,
          disabled: true
        })
      }
      else {
        return Object.assign({}, item, {
          disabled: false
        })
      }
    } else {
      return item
    }
  })

  return Object.assign({}, state, {
    fields: Array.from(fields)
  })
}

function setRequireCustomRate(state) {
  var workAmountUnitField = state.fields.find((el) => {
    return el.name === 'WorkAmountUnit';
  });

  let fields = state.fields.map(item => {
      return item
  })

  return Object.assign({}, state, {
    fields: Array.from(fields)
  })
}
